<span style="text-align: center; display: block;">
    <img data-placement="top" [title]="title" src="{{viewRecipe}}" (click)="editRecipe()"
        style="width: 20px; margin-top: -4px; height: 20px;cursor: pointer;" />
    <span [title]="pdfTooltip"><img data-placement="top" src="/assets/icons/pdf.png" [class.disabled-img]="isDisabled"
            (click)="viewPDF()"
            style="margin-left: 20px; margin-top: -4px; width: 20px; height: 20px;cursor: pointer;" /></span>
    <img data-placement="top" title="View History" src="/assets/icons/history.png" (click)="viewHistory()"
        style="margin-left: 20px; margin-top: -4px; width: 20px; height: 20px;cursor: pointer;" />
</span>